var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41217 1.66699C5.27003 1.66699 1.91217 5.02486 1.91217 9.16699C1.91217 13.3091 5.27003 16.667 9.41217 16.667C11.183 16.667 12.8105 16.0533 14.0936 15.0269L17.1562 18.0896C17.4817 18.415 18.0093 18.415 18.3348 18.0896C18.6602 17.7641 18.6602 17.2365 18.3348 16.9111L15.2721 13.8484C16.2984 12.5653 16.9122 10.9378 16.9122 9.16699C16.9122 5.02486 13.5543 1.66699 9.41217 1.66699ZM3.57884 9.16699C3.57884 5.94533 6.19051 3.33366 9.41217 3.33366C12.6338 3.33366 15.2455 5.94533 15.2455 9.16699C15.2455 12.3887 12.6338 15.0003 9.41217 15.0003C6.19051 15.0003 3.57884 12.3887 3.57884 9.16699Z",
    fill: "#667185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicro);
export default __webpack_public_path__ + "static/media/micro.8a70a7ffdbb6f12ebde9779bd523da34.svg";
export { ForwardRef as ReactComponent };